import { useFormContext, Controller } from 'react-hook-form';
import { Button, ControlLabel, FormControl, FormGroup, HelpBlock } from 'react-bootstrap';
import PasswordField from '../password-field';
import { IWorkflow } from './models/workflow';

const passwordPattern = /(?!^[0-9]*$)(?!^[a-z]*$)(?!^[A-Z]*$)^(.{8,})$/;

interface IProps {
    errorMessage: string,
    onResendCode: () => void
}

const SetPassword = (props: IProps) => {
    const { control, getValues, formState: { errors } } = useFormContext<IWorkflow>();

    return (
        <>
            <div className='verify-card-header'>
                <span className='step'>Step 2 of 3</span>
                <h4>Set Your Password</h4>
            </div>
            <div className='verify-card-body'>
                {props.errorMessage && (
                    <div className='error-notice'>{props.errorMessage}</div>
                )}

                <p>We sent a confirmation code to <strong>{getValues('emailAddress')}</strong>. It expires in one hour.</p>

                <FormGroup validationState={errors.confirmationCode != null ? 'error' : null}>
                    <ControlLabel>Confirmation code</ControlLabel>

                    <Controller
                        control={control}
                        name='confirmationCode'
                        rules={{ validate: (value) => value.trim() == '' ? 'The confirmation code is required' : undefined }}
                        render={({ field: { onChange, value } }) => (
                            <FormControl value={value} onChange={onChange} autoComplete='one-time-code' />
                        )}
                    />

                    {errors.confirmationCode != null && (
                        <HelpBlock>{errors.confirmationCode.message}</HelpBlock>
                    )}

                    <HelpBlock>
                        Didn't get it? <Button bsStyle='link' onClick={props.onResendCode}>Send a new code</Button>
                    </HelpBlock>
                </FormGroup>

                <FormGroup validationState={errors.password != null ? 'error' : null}>
                    <ControlLabel>New password</ControlLabel>

                    <Controller
                        control={control}
                        name='password'
                        rules={{
                            validate: (value) => passwordPattern.test(value)
                                ? undefined
                                : 'Password must be at least 8 characters and include a mix of numbers, lowercase and uppercase letters'
                        }}
                        render={({ field: { onChange, value } }) => (
                            <PasswordField value={value} onChange={(_, value) => onChange(value)} />
                        )}
                    />

                    {errors.password != null && (
                        <HelpBlock>{errors.password.message}</HelpBlock>
                    )}
                </FormGroup>

                <FormGroup validationState={errors.confirmPassword != null ? 'error' : null}>
                    <ControlLabel>Confirm new password</ControlLabel>

                    <Controller
                        control={control}
                        name='confirmPassword'
                        rules={{ validate: (value) => value == getValues('password') ? undefined : 'Passwords do not match' }}
                        render={({ field: { onChange, value } }) => (
                            <PasswordField value={value} onChange={(_, value) => onChange(value)} />
                        )}
                    />

                    {errors.confirmPassword != null && (
                        <HelpBlock>{errors.confirmPassword.message}</HelpBlock>
                    )}
                </FormGroup>
            </div>
            <div className='verify-card-footer'>
                <Button type='submit' bsStyle='primary'>Verify and Set Password</Button>
            </div>
        </>
    );
}

export default SetPassword;
